import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { change, getFormValues, reduxForm } from 'redux-form';

import CounterInput from '../CounterInput';
import CheckboxInput from '../CheckboxInput';
import BedConfig from '../../enums/BedConfig';
import { bookingFormInitialValues } from '../../store/reducers';
import { distributeGuestTypeCountAcrossRooms, getNoOfSelectedRooms } from '../../apiHelpers';
import withLocalize from '../../withLocalize';

// `sandamiano`: v kroku 2 se místo samostatné sady políček pro každý vybraný typ pokoje zobrazuje jen jedna společná
// sada - jako kdyby byl vybraný jen jeden typ pokoje.
class RoomOfferSandamiano extends Component {

	getTotalCapacity = () => {
		return Object.values(this.props.formValues.rooms).reduce(
			(sum, rooms) => sum + rooms.reduce((s, room) => s + room.beds + room.extrabeds, 0), 0
		);
	};

	getTotal = (getRoomValue) => {
		return Object.values(this.props.formValues.rooms).reduce(
			(sum, rooms) => sum + rooms.reduce((s, room) => s + (getRoomValue(room) || 0), 0), 0
		);
	};

	handleChange = (guestTypeId, value) => {
		const { formValues, dispatch } = this.props;
		const count = value ? parseInt(value, 10) : 0;
		distributeGuestTypeCountAcrossRooms(formValues.rooms, count, (roomTypeId, roomIndex, take) => {
			dispatch(change('bookingForm', `rooms[${roomTypeId}][${roomIndex}][guestTypes][${guestTypeId}]`, take));
		});
	};

	// Pokud host označí manželskou postel, nastavíme bedConfig prvního vybraného pokoje/lůžka na DOUBLE bez ohledu
	// na to, jestli tento typ pokoje v databázi reálně má variabilní konfiguraci postele - hodnota se pošle na server
	// stejným způsobem jako běžný typ postele
	handleDoubleBedChange = (value) => {
		const { dispatch, formValues } = this.props;

		if (value) {
			const roomTypeId = Object.keys(formValues.rooms)[0];
			if (roomTypeId) {
				dispatch(change('bookingForm', `rooms[${roomTypeId}][0][bedConfig]`, BedConfig.DOUBLE));
			}
		} else {
			for (const roomTypeId of Object.keys(formValues.rooms)) {
				formValues.rooms[roomTypeId].forEach((room, roomIndex) => {
					if (room.bedConfig === BedConfig.DOUBLE) {
						dispatch(change('bookingForm', `rooms[${roomTypeId}][${roomIndex}][bedConfig]`, null));
					}
				});
			}
		}
	};

	isDoubleBedSelected = () => {
		return Object.values(this.props.formValues.rooms).some(rooms =>
			rooms.some(room => room.bedConfig === BedConfig.DOUBLE)
		);
	};

	render() {
		const { formValues, guestTypes, apiRoomsResponse, translate: t, translatePropertyValue } = this.props;

		const isDoubleBedDisabled = !!apiRoomsResponse && apiRoomsResponse.doubleBedAvailable === false;

		return (
			<div className="room-offer room-offer--last">
				<div className="room-offer__text-container">
					{Object.values(guestTypes).map(guestType => (
						<CounterInput
							key={`guestType-${guestType.id}`}
							className="large-input--inline"
							label={translatePropertyValue(guestType.name)}
							max={this.getTotalCapacity()}
							input={{
								value: this.getTotal(room => room.guestTypes[guestType.id]),
								onChange: (value) => this.handleChange(guestType.id, value),
							}}
						/>
					))}

					{getNoOfSelectedRooms(formValues) >= 2 &&
					<CheckboxInput
						id="doubleBed"
						label={t('SelectedRooms.index.doubleBed')}
						disabled={isDoubleBedDisabled}
						input={{
							value: this.isDoubleBedSelected(),
							onChange: this.handleDoubleBedChange,
						}}
					/>
					}
				</div>
			</div>
		);
	}
}

export default compose(
	reduxForm({
		form: 'bookingForm',
		initialValues: bookingFormInitialValues,
		destroyOnUnmount: false,
	}),
	connect(state => ({
		formValues: getFormValues('bookingForm')(state),
		guestTypes: state.app.guestTypes,
		apiRoomsResponse: state.app.apiRoomsResponse,
	})),
	withLocalize,
)(RoomOfferSandamiano);



// WEBPACK FOOTER //
// ./src/components/SelectedRooms/RoomOfferSandamiano.jsx